//
//
//
//
//
//
//
//


export default {
  name: 'TabItem',
  props: {
    activeClass: String,
    selected: {
      type: Boolean,
      default: false,
    },
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/Tab/TabItem.vue